export enum BROWSER_TYPE {
    SAFARI = 'safari',
    CHROME = 'chrome',
    FIREFOX = 'firefox',
}
